<div class="page-title" data-cy="spo-title">SPO</div>
<div class="spo-list">
    <app-spo-list (reportCriteria)="setReportCriteria($event)"></app-spo-list>
</div>
